import { StyleThemingProps } from '~/utils/styleHelpers'

import { asChakraVariable } from '@mangovoice/design-system'

import { CircleBadgeVariant } from './CircleBadge.style'

export const PulsingCircleBadgeStyle = {
  baseStyle: {
    boxSize: '1rem',
    borderRadius: 'full',
    animation: 'backgroundPulse 1s infinite alternate',
  },
  variants: {
    [CircleBadgeVariant.Blue]: {
      '@keyframes backgroundPulse': {
        from: {
          background: asChakraVariable({
            default: 'blue.subtle',
          }),
        },
        to: {
          background: asChakraVariable({
            default: 'blue.muted',
          }),
        },
      },
    },
    [CircleBadgeVariant.Green]: {
      '@keyframes backgroundPulse': {
        from: {
          background: asChakraVariable({
            default: 'green.subtle',
          }),
        },
        to: {
          background: asChakraVariable({
            default: 'green.muted',
          }),
        },
      },
    },
    [CircleBadgeVariant.Red]: {
      '@keyframes backgroundPulse': {
        from: {
          background: asChakraVariable({
            default: 'red.subtle',
          }),
        },
        to: {
          background: asChakraVariable({
            default: 'red.muted',
          }),
        },
      },
    },
    [CircleBadgeVariant.Gray]: {
      '@keyframes backgroundPulse': {
        from: {
          background: asChakraVariable({
            default: 'gray.subtle',
          }),
        },
        to: {
          background: asChakraVariable({
            default: 'gray.muted',
          }),
        },
      },
    },
  },
}

export const usePulsingCircleBadgeStyle = (props: StyleThemingProps) => {
  // PulsingCircleBadgeStyle is a single-part component, so we just merge and return the styles directly
  const { variants, baseStyle = {} } = PulsingCircleBadgeStyle
  const { variant } = props
  const variantKey = variant as CircleBadgeVariant | undefined

  return {
    ...baseStyle,
    ...(variantKey && variantKey in variants ? variants[variantKey] : {}),
  }
}
